import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';
import { RifoExlusiveModels } from '../../../models/rifo.exlusives';
import { capitalize } from '../../../utils/baseurl.encoder';

@HimuraInject.NamedService('RifoExlusiveListDelegate')
export class RifoExlusiveListDelegate extends DataDelegate {
    public totalItems: number = 100;

    public currentPage: number = 100;

    public totalItemsMy: number = 100;

    public currentPageMy: number = 100;

    public dataList: any = [];

    public dataListMy: any = [];

    constructor() {
        super('RifoExlusiveListDelegate');
    }

    public clear() {
        this.clearData();
        this.dataListMy = [];
        this.dataList = [];
    }

    public async getListings(page: number, agentId = 'all') {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        let requestParams: any = {};
        if (agentId === 'all') {
            this.dataList = [];
            requestParams = {
                'rifoPropertyType': 'hidden-listing',
                'pageSize': '10',
                'pageNum': `${page}`,
                'ltype': `0`,
            };
            const requestParamsStr = Object.keys(requestParams).map(function(k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(requestParams[k]);
            }).join('&');
            const fetched = await AxiosPromise.get(`${apiHost}/rifoListings/findAll?` + requestParamsStr);
            if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
                this.totalItems = fetched.data.totalRecord;
                this.currentPage = page;
                if (T_T.simpleDetect(fetched.data) && fetched.data.content) {
                    const data: RifoExlusiveModels.IListRow[] = fetched.data.content.filter((v: any) => v.active).map((v: any) => this._listingMapper(v));
                    this.dataList = data;
                }
                return 1;
            } else {
                return 0;
            }
        } else {
            this.dataListMy = [];
            requestParams = {
                'rifoPropertyType': 'hidden-listing',
                'pageSize': '10',
                'pageNum': `${page}`,
                'ltype': `0`,
                'agentId': agentId,
            };
            const requestParamsStr = Object.keys(requestParams).map(function(k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(requestParams[k]);
            }).join('&');
            const fetched = await AxiosPromise.get(`${apiHost}/rifoListings/findAll?` + requestParamsStr);
            if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
                this.totalItemsMy = fetched.data.totalRecord;
                this.currentPageMy = page;
                if (T_T.simpleDetect(fetched.data) && fetched.data.content) {
                    const data: RifoExlusiveModels.IListRow[] = fetched.data.content.filter((v: any) => v.active).map((v: any) => this._listingMapper(v));
                    this.dataListMy = data;
                }
                return 1;
            } else {
                return 0;
            }
        }
    }

    private _listingMapper(v: any) {
        const province = T_T.simpleDetect(v.province) ? v.province : '';
        const city = T_T.simpleDetect(v.city) ? v.city : '';
        const streetNumber = T_T.simpleDetect(v.address.streetNumber) ? v.address.streetNumber : '';
        const streetName = T_T.simpleDetect(v.address.streetName) ? v.address.streetName : '';
        const postalCode = T_T.simpleDetect(v.address.postalCode) ? v.address.postalCode : '';
        const fullAddress = T_T.simpleDetect(v.fullAddress) ? v.fullAddress : `${streetNumber} ${capitalize(streetName)} ${postalCode}, ${city}, ${province}`;
        const result: RifoExlusiveModels.IListRow = {
            identifier: v.identifier,
            picture: v.pictures.length > 0 ? v.pictures[0] : ``,
            title: T_T.simpleDetect(v.preConstructionName) ? v.preConstructionName : ``,
            fullAddress: fullAddress,
            location: {
                streetNumber: streetNumber,
                streetName: streetName,
                postalCode: postalCode,
                country: '',
                province: province,
                region: '',
                city: city,
            },
            price: T_T.simpleDetect(v.price) ? v.price : ``,
            bedrooms: T_T.simpleDetect(v.bedrooms) ? v.bedrooms : ``,
            bedroomsPlus: T_T.simpleDetect(v.bedroomsPlus) ? v.bedroomsPlus : ``,
            washrooms: T_T.simpleDetect(v.washrooms) ? v.washrooms : ``,
            garages: T_T.simpleDetect(v.garages) ? v.garages : ``,
            parkingSpaces: T_T.simpleDetect(v.parkingSpaces) ? v.parkingSpaces : ``,
            remark: T_T.simpleDetect(v.remarks) ? v.remarks.client : ``,
            agentId: T_T.simpleDetect(v.agents) ? v.agents.length > 0 ? v.agents[0].id : null : null,
        };
        return result;
    }
}
